<template>
  <v-card class="">
    <v-card-title class="d-flex justify-center">
      <div class="green lighten-2 pa-3 rounded">
        <v-img
          max-height="150"
          max-width="250"
          src="https://suite.ce.gov.br/img/LOGIN_LOGO.68c5ce75.png"
          
        />
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text class="text-subtitle-1 text-center">
      <p class="ma-0">
        Os processos abertos a partir de 2024 são criados no Sistema Único
        Integrado de Tramitação Eletrônica (Suite) da SEPLAG.
      </p>
      <p class="ma-0">
        Acessar o sistema no link
        <a
          href="https://suite.ce.gov.br/"
          target="_blank"
        >https://suite.ce.gov.br/</a>
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import ProcessoService from "@/services/processo-eletronico/processo.service";
import TramitacaoService from "@/services/processo-eletronico/tramitacao.service";

import { mask } from "vue-the-mask";
import { delay } from "rxjs/operators";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import GlobalStore from "@/store/modules/global";

export default Vue.extend({
  components: {},
  directives: {
    mask,
  },
  metaInfo: {
    title: "Consulta de Processos - Central de Serviços",
  },
  filters: {
    formatDate: (dateToFormat, pattern) => moment(dateToFormat).format(pattern),
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    loadingTramitations: false,
    formModel: {
      valid: false,
      recaptcha: null,
      viproc: "",
    },
    processo: null,
    tramitacoes: [],
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
      pattern: (value) =>
        !!value.match(/^([0-9])*\/[0-9]{4}$/) ||
        "Esse campo está fora do padrão",
    },
    page: 1,
    size: 15,
    endTramitations: false,
    error: "",
    urlLogo: "img/logo-arce.png",
    modeTimeline: false,
    items: [{ key: "viproc", text: "Viproc" }],
  }),
  mounted() {
    moment.locale("pt-br");
    this.verifyWidth(window.innerWidth);
    //this.initData();
  },
  methods: {
    clearFieldNumber() {
      this.formModel.viproc = null;
    },
    verifyRecaptcha(value) {
      this.formModel.recaptcha = value;
      this.initData();
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.formModel.recaptcha = null;
    },
    initData() {
      const { query } = this.$route;
      if (query && query.numero) {
        this.formModel.viproc = query.numero;
        this.onSubmit();
      }
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.endTramitations = false;
        this.page = 1;
        this.tramitacoes = [];
        this.loadData();
      }
    },
    loadData() {
      this.isLoading = true;
      const recaptcha = this.formModel.recaptcha;

      ProcessoService.findByViproc(this.formModel.viproc, recaptcha).subscribe(
        (response) => {
          this.processo = response;
          this.isLoading = false;
          this.expiredRecaptcha();
          this.scrollToProcesso();
          this.loadTramitacoes();
        },
        (error) => {
          this.expiredRecaptcha();
          this.processo = null;
          this.isLoading = false;
        }
      );
    },
    loadTramitacoes() {
      TramitacaoService.findByProcessoId(
        this.processo.id,
        this.page,
        this.size
      ).subscribe(
        (response) => {
          if (this.processo) {
            this.tramitacoes = response;
          }
          this.isLoading = false;
          if (this.tramitacoes.length === 0) {
            let message = "Não existem movimentações para esse processo.";
            GlobalStore.setSnackBar({ show: true, type: "error", message });
          }
        },
        (error) => {
          this.expiredRecaptcha();
          this.tramitacoes = [];
          this.isLoading = false;
        }
      );
    },
    clear() {
      this.processo = null;
      this.tramitacoes = [];
      this.formModel.viproc = "";
    },
    onScroll() {
      const { documentElement } = document;
      let bottomOfWindow =
        documentElement.scrollTop + window.innerHeight ===
        documentElement.offsetHeight;

      if (
        bottomOfWindow &&
        !this.endTramitations &&
        this.tramitacoes &&
        this.processo
      ) {
        this.page += 1;
        this.loadingTramitations = true;
        TramitacaoService.findByProcessoId(
          this.processo.id,
          this.page,
          this.size
        )
          .pipe(delay(1000))
          .subscribe(
            (tramitacoes) => {
              if (tramitacoes.length > 0) {
                this.tramitacoes.push(...tramitacoes);
              } else {
                this.endTramitations = true;
              }
            },
            (error) => {
              this.tramitacoes = [];
              throw error;
            },
            () => {
              this.loadingTramitations = false;
            }
          );
      }
    },
    onResize() {
      this.verifyWidth(window.innerWidth);
    },
    verifyWidth(size) {
      this.modeTimeline = size <= 767;
    },
    changeStatusTramitacao(key, status) {
      if (key === 0 && this.processo && this.processo.dataEncerramento) {
        return "FINALIZADO";
      } else if (key === 0) {
        return "RECEBIDO (FASE ATUAL)";
      } else {
        return status;
      }
    },
    scrollToProcesso() {
      this.$vuetify.goTo("#card-processo");
    },
  },
});
</script>

<style lang="scss">
input {
  text-transform: uppercase;
}
.area-loading {
  text-align: center;
  margin: 10px;
  .v-progress-circular {
    margin-right: 10px;
  }
}
.loading-tramitacoes {
  margin: auto;
  display: table;
}
.v-alert__content {
  font-weight: 500;
}
</style>
